import React from 'react'
import { Button } from '@ecommerce/shared'
import { ActionButton, Body, Container, Description, Inner, Title, TitleWrapper, Wrapper } from './styled'
import { Icon } from '../../../components/Icon/Icon'

interface CustomizableProductModalProps {
  onClose: () => void
}

const CustomizableProductModal = ({ onClose }: CustomizableProductModalProps) => {
  return (
    <Wrapper zIndex="10">
      <Inner>
        <Container>
          <Body>
            <TitleWrapper>
              <Icon iconId="info-fill-new" />
              <Title>Falta personalizar tu botella</Title>
            </TitleWrapper>
            <Description>
              Llevas un producto personalizable en tu carrito.
              <br />
              Para completar la compra, por favor ingresa un nombre para personalizarlo
            </Description>
          </Body>
          <ActionButton>
            <Button className="button" onClick={onClose}>
              Entendido
            </Button>
          </ActionButton>
        </Container>
      </Inner>
    </Wrapper>
  )
}

export default CustomizableProductModal
